import { render, staticRenderFns } from "./founds.vue?vue&type=template&id=8dbc3c8e&scoped=true&"
import script from "./founds.vue?vue&type=script&lang=js&"
export * from "./founds.vue?vue&type=script&lang=js&"
import style0 from "./founds.vue?vue&type=style&index=0&id=8dbc3c8e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbc3c8e",
  null
  
)

export default component.exports